export type WorkoutExerciseDetailSource = {
  category?: string | null
  sets?: number | null
  reps?: number | null
  durationMinutes?: number | null
  distanceKm?: number | null
  elevationGainMeters?: number | null
}

type WorkoutExerciseDetailsOptions = {
  formatDistance: (distanceKm: number) => string
  formatElevation: (elevationGainMeters: number) => string
}

const hasPositiveValue = (value: number | null | undefined): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value > 0

const isElevationExercise = (exercise: WorkoutExerciseDetailSource) =>
  exercise.category?.toLowerCase() === 'elevation'

export const formatWorkoutExerciseDetails = (
  exercise: WorkoutExerciseDetailSource,
  options: WorkoutExerciseDetailsOptions
) => {
  const details: string[] = []

  if (exercise.sets != null && exercise.reps != null) {
    details.push(`${exercise.sets}x${exercise.reps}`)
  }

  if (exercise.durationMinutes != null) {
    details.push(`${exercise.durationMinutes} min`)
  }

  if (hasPositiveValue(exercise.distanceKm)) {
    details.push(options.formatDistance(exercise.distanceKm))
  }

  if (isElevationExercise(exercise) && hasPositiveValue(exercise.elevationGainMeters)) {
    details.push(options.formatElevation(exercise.elevationGainMeters))
  }

  return details.join(' | ')
}
